import React from 'react';  
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';  
import ChooseProduct from "./ChooseProduct"

const Home = () => {  
  return (  
  <ChooseProduct/>
    );  
};  

export default Home;  